let _ctx = null;

const SOUND_PREF_KEY = "viki-sounds-enabled";

export const vikiSoundsEnabled = () => localStorage.getItem(SOUND_PREF_KEY) !== "off";

export const setVikiSoundsEnabled = (on) => localStorage.setItem(SOUND_PREF_KEY, on ? "on" : "off");

const ensureCtx = () => {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!_ctx) _ctx = new AC();
  if (_ctx.state === "suspended") _ctx.resume().catch(() => {});
  return _ctx;
};

const tone = (ctx, freq, startAt, dur, peak) => {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;
  const t = ctx.currentTime + startAt;
  gain.gain.setValueAtTime(0.0001, t);
  gain.gain.exponentialRampToValueAtTime(peak, t + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  osc.connect(gain).connect(ctx.destination);
  osc.start(t);
  osc.stop(t + dur + 0.05);
};

export const playVikiReply = () => {
  if (!vikiSoundsEnabled()) return;
  try {
    const ctx = ensureCtx();
    if (!ctx) return;
    tone(ctx, 660, 0, 0.14, 0.035);
    tone(ctx, 990, 0.09, 0.2, 0.03);
  } catch {
    /* audio non disponibile: silenzio, nessun errore visibile */
  }
};

export const playVikiNotify = () => {
  if (!vikiSoundsEnabled()) return;
  try {
    const ctx = ensureCtx();
    if (!ctx) return;
    tone(ctx, 880, 0, 0.12, 0.04);
    tone(ctx, 1174.7, 0.1, 0.16, 0.035);
    tone(ctx, 880, 0.24, 0.22, 0.025);
  } catch {
    /* audio non disponibile */
  }
};

/* --- Voce di VIKI: sintesi vocale (OpenAI TTS lato backend).
   Usata ESCLUSIVAMENTE dalla modalità mani libere del widget: ogni altro
   punto di accesso alla voce (Ascolta, interruttore, briefing) è stato
   rimosso su decisione del titolare (06/2026). --- */
import { api } from "../context/AuthContext";

let _voiceAudio = null;

export const stopVikiSpeech = () => {
  if (_voiceAudio) {
    _voiceAudio.pause();
    _voiceAudio = null;
  }
};

export const speakViki = async (text, { waitEnd = false } = {}) => {
  if (!text) return false;
  stopVikiSpeech();
  try {
    const res = await api.post("/viki/tts", { text }, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const audio = new Audio(url);
    _voiceAudio = audio;
    const cleanup = () => {
      URL.revokeObjectURL(url);
      if (_voiceAudio === audio) _voiceAudio = null;
    };
    if (waitEnd) {
      await new Promise((resolve) => {
        audio.onended = () => { cleanup(); resolve(); };
        audio.onpause = () => { resolve(); };
        audio.onerror = () => { cleanup(); resolve(); };
        audio.play().catch(() => { cleanup(); resolve(); });
      });
    } else {
      audio.onended = cleanup;
      await audio.play();
    }
    return true;
  } catch {
    return false;
  }
};
